import { useTranslate } from '@tolgee/react';
import { useGetTimes } from 'views/Aide/Scenario/RoundForm.tsx';
import { LogItemProps } from '../LogItemLayout';
import { useScenarioLabel } from '../useUtils';

export const useTitle = (data: LogItemProps['data']) => {
  const { t } = useTranslate();
  const { operateType, scenarioType, round, changeField } = data;
  const scenarioLabel = useScenarioLabel(scenarioType);
  const { getTimes } = useGetTimes();

  const name = t('marketing.第x次action', {
    x: getTimes(round),
    action: scenarioLabel,
  });

  const renderChange = () => {
    if (changeField === 'ROUND_EXECUTE_TIME' || changeField === 'ROUND_EXECUTE_TIME_UNIT') {
      return t('TaskOperationLog.updateRound', {
        name,
        field: `-${t('marketing.执行时间')}`,
      });
    }
  };

  if (operateType === 'CREATE_ROUND') {
    return t('TaskOperationLog.addRound', { name: name });
  } else if (operateType === 'DELETE_ROUND') {
    return t('TaskOperationLog.delRound', { name: name });
  } else if (operateType === 'UPDATE_ROUND') {
    return renderChange();
  } else {
    return null;
  }
};
